import React, { useState } from 'react';
import { Link, withRouter, useHistory } from 'react-router-dom';
import Api from '../../Services/Api';
import Alert from '../../Services/Alert';

const MODULES = [
    { key: 'dashboard',         label: 'Dashboard',              icon: 'bx-home-circle' },
    { key: 'users',             label: 'Users List',             icon: 'bx-user-circle' },
    { key: 'inactiveUsers',     label: 'Inactive Users',         icon: 'bx-user-x' },
    { key: 'deletedAccounts',   label: 'Deleted Accounts',       icon: 'bx-trash' },
    { key: 'dailyReports',      label: 'Daily Reports',          icon: 'bx-bar-chart-alt' },
    { key: 'bidReports',        label: 'Win / Place Bid Reports',icon: 'bx-receipt' },
    { key: 'bidUpdateReports',  label: 'Bid Update Reports',     icon: 'bx-revision' },
    { key: 'bulkWithdrawals',   label: 'Bulk Withdrawals',       icon: 'bx-money-withdraw' },
    { key: 'withdrawals',       label: 'Withdrawals List',       icon: 'bx-credit-card' },
    { key: 'transactions',      label: 'Market Transactions',    icon: 'bx-transfer' },
    { key: 'addMoney',          label: 'Add Money',              icon: 'bx-wallet' },
    { key: 'paymentStatus',     label: 'Payment Status',         icon: 'bx-check-circle' },
    { key: 'markets',           label: 'Markets List',           icon: 'bx-store' },
    { key: 'noticeBoard',       label: 'Notice Board',           icon: 'bx-clipboard' },
    { key: 'notifications',     label: 'Notifications',          icon: 'bx-bell' },
    { key: 'uploadApk',         label: 'Upload APK',             icon: 'bx-upload' },
    { key: 'settings',          label: 'Settings',               icon: 'bx-cog' },
    { key: 'subAdmins',         label: 'Roles & Permissions',    icon: 'bx-shield-quarter' },
    { key: 'clearData',         label: 'Clear Data',             icon: 'bx-trash-alt' },
    { key: 'chatSupport',       label: 'Live Support Chat',      icon: 'bx-message-dots' },
];

const defaultPermissions = () => {
    const p = {};
    MODULES.forEach(m => { p[m.key] = { read: false, write: false, delete: false }; });
    return p;
};

export const SubAdminAdd = (props) => {
    const history = useHistory();
    const [form, setForm] = useState({
        firstname: '', lastname: '', email: '', password: '', confirmPassword: '', role: 'subadmin'
    });
    const [permissions, setPermissions] = useState(defaultPermissions());
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
        setErrors(prev => ({ ...prev, [e.target.name]: '' }));
    };

    const handlePermChange = (module, action, value) => {
        setPermissions(prev => ({
            ...prev,
            [module]: { ...prev[module], [action]: value }
        }));
    };

    const handleSelectAll = (module, checked) => {
        setPermissions(prev => ({
            ...prev,
            [module]: { read: checked, write: checked, delete: checked }
        }));
    };

    const handleSelectAllModules = (checked) => {
        const p = {};
        MODULES.forEach(m => { p[m.key] = { read: checked, write: checked, delete: checked }; });
        setPermissions(p);
    };

    const validate = () => {
        const errs = {};
        if (!form.firstname.trim()) errs.firstname = 'First name is required';
        if (!form.lastname.trim()) errs.lastname = 'Last name is required';
        if (!form.email.trim()) errs.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = 'Invalid email format';
        if (!form.password.trim()) errs.password = 'Password is required';
        else if (form.password.length < 6) errs.password = 'Min 6 characters required';
        if (form.password !== form.confirmPassword) errs.confirmPassword = 'Passwords do not match';
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);
        const payload = {
            firstname: form.firstname,
            lastname: form.lastname,
            email: form.email,
            password: form.password,
            role: form.role,
            permissions
        };
        Api.post('roles/sub-admins/create', payload)
            .then(res => res.data)
            .then(res => {
                setLoading(false);
                if (res.status) {
                    Alert.success(res.message);
                    history.push('/roles/sub-admins');
                } else {
                    Alert.error(res.message);
                }
            })
            .catch(err => { setLoading(false); Alert.error(err.message); });
    };

    const allSelected = MODULES.every(m => {
        const p = permissions[m.key] || {};
        return p.read && p.write && p.delete;
    });

    return (
        <section className="main-content">
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 font-size-18">
                                <i className="bx bx-user-plus me-2" style={{ color: '#556ee6' }}></i>
                                Add Sub-Admin
                            </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to="/roles/sub-admins">Sub-Admins</Link></li>
                                    <li className="breadcrumb-item active">Add</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="row">
                        {/* Basic Info */}
                        <div className="col-lg-5">
                            <div className="card" style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(85,110,230,0.1)' }}>
                                <div className="card-header" style={{ background: 'linear-gradient(135deg, #556ee6 0%, #6f42c1 100%)', borderRadius: '12px 12px 0 0' }}>
                                    <h5 className="mb-0 text-white">
                                        <i className="bx bx-user-circle me-2"></i>Account Details
                                    </h5>
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-6">
                                            <label className="form-label fw-semibold">First Name <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                name="firstname"
                                                className={`form-control ${errors.firstname ? 'is-invalid' : ''}`}
                                                placeholder="First name"
                                                value={form.firstname}
                                                onChange={handleChange}
                                                id="firstname"
                                            />
                                            {errors.firstname && <div className="invalid-feedback">{errors.firstname}</div>}
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label fw-semibold">Last Name <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                name="lastname"
                                                className={`form-control ${errors.lastname ? 'is-invalid' : ''}`}
                                                placeholder="Last name"
                                                value={form.lastname}
                                                onChange={handleChange}
                                                id="lastname"
                                            />
                                            {errors.lastname && <div className="invalid-feedback">{errors.lastname}</div>}
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Email Address <span className="text-danger">*</span></label>
                                            <input
                                                type="email"
                                                name="email"
                                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                placeholder="email@example.com"
                                                value={form.email}
                                                onChange={handleChange}
                                                id="email"
                                            />
                                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Password <span className="text-danger">*</span></label>
                                            <input
                                                type="password"
                                                name="password"
                                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                placeholder="Min 6 characters"
                                                value={form.password}
                                                onChange={handleChange}
                                                id="password"
                                            />
                                            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Confirm Password <span className="text-danger">*</span></label>
                                            <input
                                                type="password"
                                                name="confirmPassword"
                                                className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                                placeholder="Repeat password"
                                                value={form.confirmPassword}
                                                onChange={handleChange}
                                                id="confirmPassword"
                                            />
                                            {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                                        </div>
                                    </div>

                                    {/* Role Selector */}
                                    <div className="mt-3">
                                        <label className="form-label fw-semibold">Role <span className="text-danger">*</span></label>
                                        <select
                                            name="role"
                                            className="form-select"
                                            value={form.role}
                                            onChange={handleChange}
                                            id="role"
                                        >
                                            <option value="subadmin">Sub Admin</option>
                                            <option value="supervisor">Supervisor</option>
                                            <option value="support_agent">Support Agent (Chat Only)</option>
                                        </select>
                                        <div className="text-muted small mt-1">
                                            {form.role === 'support_agent'
                                                ? '🎧 Support Agents can only access the Chat module.'
                                                : form.role === 'supervisor'
                                                ? '👁️ Supervisors can view all chats and assign agents.'
                                                : '🛡️ Sub-Admin access is controlled through permissions below.'}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer text-end" style={{ borderRadius: '0 0 12px 12px' }}>
                                    <Link to="/roles/sub-admins" className="btn btn-secondary me-2">Cancel</Link>
                                    <button type="submit" className="btn btn-primary" disabled={loading} id="submit-btn">
                                        {loading ? <span className="spinner-border spinner-border-sm me-1"></span> : <i className="bx bx-save me-1"></i>}
                                        Create Sub-Admin
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Permissions Table */}
                        <div className="col-lg-7">
                            <div className="card" style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(85,110,230,0.1)' }}>
                                <div className="card-header" style={{ background: 'linear-gradient(135deg, #556ee6 0%, #6f42c1 100%)', borderRadius: '12px 12px 0 0' }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0 text-white">
                                            <i className="bx bx-shield-quarter me-2"></i>Permissions Matrix
                                        </h5>
                                        <div className="form-check form-switch mb-0">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="select-all-modules"
                                                checked={allSelected}
                                                onChange={e => handleSelectAllModules(e.target.checked)}
                                                style={{ width: '40px', height: '20px' }}
                                            />
                                            <label className="form-check-label text-white" htmlFor="select-all-modules">
                                                Grant All
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <thead style={{ background: '#f8f9fa' }}>
                                                <tr>
                                                    <th style={{ width: '40%' }}>Module</th>
                                                    <th className="text-center">All</th>
                                                    <th className="text-center"><i className="bx bx-show me-1 text-primary"></i>Read</th>
                                                    <th className="text-center"><i className="bx bx-edit me-1 text-warning"></i>Write</th>
                                                    <th className="text-center"><i className="bx bx-trash me-1 text-danger"></i>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {MODULES.map((mod) => {
                                                    const mp = permissions[mod.key] || { read: false, write: false, delete: false };
                                                    const allChecked = mp.read && mp.write && mp.delete;
                                                    return (
                                                        <tr key={mod.key} className={allChecked ? 'table-primary' : ''}>
                                                            <td>
                                                                <i className={`bx ${mod.icon} me-2 text-primary`}></i>
                                                                <strong>{mod.label}</strong>
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={allChecked}
                                                                    id={`add-all-${mod.key}`}
                                                                    onChange={e => handleSelectAll(mod.key, e.target.checked)}
                                                                    style={{ width: '17px', height: '17px' }}
                                                                />
                                                            </td>
                                                            {['read', 'write', 'delete'].map(action => (
                                                                <td key={action} className="text-center">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={mp[action] || false}
                                                                        id={`add-${mod.key}-${action}`}
                                                                        onChange={e => handlePermChange(mod.key, action, e.target.checked)}
                                                                        style={{ width: '17px', height: '17px' }}
                                                                    />
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        </section>
    );
};

export default withRouter(SubAdminAdd);
